// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__T2Nsk","hidden":"styles_hidden__74kDT","shown":"styles_shown__BKjqp"};